import React from 'react';
import { graphql } from 'gatsby';
import LitStructuredText from './generic/LitStructuredText';
import LitImage from './images/LitImage';
const ModularHeaderParagraphList = ({ data }) => {
  const { backgroundColor, iconParagraphList, header, paragraph } = data;
  return (
    <div
      className={`${backgroundColor} modular-header-paragraph-list-container`}
    >
      <div className="modular-header-paragraph-list-inner modular-global-width modular-p modular-padding-large">
        <LitStructuredText data={header} basic />
        <LitStructuredText data={paragraph} basic />
        <div className="icon-paragraph-list-container">
          {iconParagraphList.map(({ icon, paragraph, id, heading }) => {
            return (
              <div className="icon-paragraph-list-inner" key={id}>
                <div className="icon-paragraph-list-image">
                  <LitImage image={icon} alt="black illustrated icon" />
                </div>
                {heading && <LitStructuredText data={heading} basic />}
                <LitStructuredText data={paragraph} basic />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ModularHeaderParagraphList;

export const fragment = graphql`
  fragment ModularHeaderParagraphList on DatoCmsHeaderParagraphList {
    internal {
      type
    }
    backgroundColor
    iconParagraphList {
      icon {
        gatsbyImageData
      }
      heading {
        value
      }
      paragraph {
        value
      }
      id
    }
    header {
      value
    }
    paragraph {
      value
    }
  }
`;
